import { PagePending } from "@/components/ui/PagePending";
import { PageWrapper } from "@/components/ui/PageWrapper";
import { seo } from "@/utils/seo";
import { Box, Flex } from "@givenwell/components";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useState } from "react";
import { ReportsToolbarContext } from "./ReportsToolbar";

export const Route = createFileRoute("/supporter/$supporterId/allowance-reports")({
  pendingComponent: PagePending,
  component: RouteComponent,
  head: () => ({ meta: seo({ title: "Allowance Report" }) }),
});

function RouteComponent() {
  const [toolbar, setToolbar] = useState<HTMLDivElement | null>(null);

  return (
    <ReportsToolbarContext.Provider value={toolbar}>
      <PageWrapper
        title="Allowance Reports"
        maxWidth={1400}
        rightContent={<div ref={setToolbar} style={{ display: "contents" }} />}
      >
        <Flex css={{ flexDirection: "column", flex: "1 0 0px" }}>
          <ReportTabs />
          <Box css={{ flex: "1 0 0px", display: "flex", flexDirection: "column" }}>
            <Outlet />
          </Box>
        </Flex>
      </PageWrapper>
    </ReportsToolbarContext.Provider>
  );
}

import { TabNav, TabNavItem } from "@/components/ui/TabNav";

function ReportTabs() {
  return (
    <Box css={{ mb: 16 }}>
      <TabNav>
        <TabNavItem from="/supporter/$supporterId/allowance-reports" to="./utilisation">
          Utilisation & Trends
        </TabNavItem>
        <TabNavItem from="/supporter/$supporterId/allowance-reports" to="./forecast">
          History
        </TabNavItem>
        <TabNavItem from="/supporter/$supporterId/allowance-reports" to="./insights">
          Spending Insights
        </TabNavItem>
        <TabNavItem from="/supporter/$supporterId/allowance-reports" to="./spend">
          Spending Report
        </TabNavItem>
      </TabNav>
    </Box>
  );
}
